import React from 'react';
import { Box, Typography } from '@mui/material';

import GOOD_SHIELD_ICON from '../assets/good.png';
import BAD_SHIELD_ICON from '../assets/bad.png';
import INFO_SHIELD_ICON from '../assets/info.png';
import SUSPICIOUS_SHIELD_ICON from '../assets/suspicious.png';

const DisplayResultPanel = ({ alertPanelData }) => {
  return (
    <>
      {alertPanelData.level === 'error' &&
        <>
          <Box marginTop={'10px'} border={'1px solid #757575'} padding={'8px 16px'} display='flex' flexDirection='row' alignItems='center'>
            <img src={BAD_SHIELD_ICON} style={{ width: '24px', height: '24px', marginRight: '8px' }} />
            <Typography variant="body1" style={{ color: '#D32F2F' }}>
              {alertPanelData.text}
            </Typography>
          </Box>
        </>
      }
      {alertPanelData.level === 'warning' &&
        <>
          <Box marginTop={'10px'} border={'1px solid #757575'} padding={'8px 16px'} display='flex' flexDirection='row' alignItems='center'>
            <img src={SUSPICIOUS_SHIELD_ICON} style={{ width: '24px', height: '24px', marginRight: '8px' }} />
            <Typography variant="body1" style={{ color: '#ED6C02' }}>
              {alertPanelData.text}
            </Typography>
          </Box>
        </>
      }
      {alertPanelData.level === 'success' &&
        <>
          <Box marginTop={'10px'} border={'1px solid #757575'} padding={'8px 16px'} display='flex' flexDirection='row' alignItems='center'>
            <img src={GOOD_SHIELD_ICON} style={{ width: '24px', height: '24px', marginRight: '8px' }} />
            <Typography variant="body1" style={{ color: '#2E7D32' }}>
              {alertPanelData.text}
            </Typography>
          </Box>
        </>
      }
      {alertPanelData.level === 'info' &&
        <>
          <Box marginTop={'10px'} border={'1px solid #757575'} padding={'8px 16px'} display='flex' flexDirection='row' alignItems='center'>
            <img src={INFO_SHIELD_ICON} style={{ width: '24px', height: '24px', marginRight: '8px' }} />
            <Typography variant="body1" style={{ color: '#2986CC' }}>
              {alertPanelData.text}
            </Typography>
          </Box>
        </>
      }
    </>
  )
}

export default DisplayResultPanel;